<template>
  <div class="containerTable">
    <vxe-toolbar id="toolbarId_bi2" :custom="{storage: true}" export :refresh="{query: RefreshList}">
      <template v-slot:buttons>
        <el-button @click="funcFilter">查询</el-button>
        <el-button @click="funcAdd">新增</el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      highlight-hover-row
      row-id="id"
      height="80%"
      :loading="loading"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"     
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column field="phone" title="账号" min-width="60" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.phone" placeholder="请输入账号" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column min-width="100">
        <vxe-table-column field="name" title="姓名" min-width="60" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.name" placeholder="请输入姓名" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="roleList"
          :formatter="formatterRoleName"
          title="角色"
          min-width="100"
        />
        <template v-slot:header>
          <el-select v-model="listQuery.roleCode" clearable placeholder="请选择">
            <el-option
              v-for="item in roleList"
              :key="item.code"
              :label="item.roleName"
              :value="item.code"
            >
              <span style="float:left">{{ item.roleName }}</span>
              <span style="float: right ; color: #8492a6; font-size: 12px">&nbsp;&nbsp;{{ item.branchName }}</span>
            </el-option>
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column :formatter="groupNameFormatter" title="所属机构" min-width="350" sortable />
        <template v-slot:header>
          <groupSelect ref="groupSelect" @setGroupCode="setOrgCode" />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="gmtCreated" title="创建时间" min-width="250" sortable />
        <template v-slot:header>
          <div class="block">
            <el-date-picker
              v-model="listQuery.gmtCreatedRange"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="optionsPicker"
              :default-time="['00:00:00', '23:59:59']"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="value => changeDate(value, 'gmtCreated')"
            />
          </div>
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" fixed="right" min-width="80">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="编辑" placement="top">
            <vxe-button type="text" @click="funcEdit(scope.row.code)">
              <i class="el-icon-edit" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="删除" placement="top">
            <vxe-button type="text" @click="funcDelete(scope.row.code)">
              <i class="el-icon-delete" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :page-sizes="Pagingconf"
      :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']"
      @page-change="handlePageChange"
    />

    <vxe-modal v-model="modelAddFlag" title="新增" width="600" height="380" resize>
      <compAdd ref="addRef" @fatherAddMethod="fatherAdd" @fatherCancelMethod="fatherCancel" />
    </vxe-modal>
    <vxe-modal v-model="modelEditFlag" title="编辑" width="600" height="400" resize>
      <compEdit ref="editRef" @fatherEditMethod="fatherEdit" @fatherCancelMethod="fatherCancel" />
    </vxe-modal>
    <vxe-modal v-model="modelDetailFlag" title="详情" width="600" height="320" resize>
      <compDetail ref="detailRef" />
    </vxe-modal>
  </div>
</template>
<script>
import compAdd from './components/userLoginAdd.vue'
import compEdit from './components/userLoginEdit.vue'
import compDetail from './components/userLoginDetail.vue'
import request from '@/utils/request'
import groupSelect from "./components/groupSelect";
export default {
  name: 'PartyList',
  components: {
    compAdd,
    compEdit,
    compDetail,
    groupSelect
  },
  data() {
    return {
       
      message: '',
      loading: false,
      cascadeData:[],
      tableData: [],
      modelAddFlag: false,
      modelEditFlag: false,
      modelDetailFlag: false,
      copy: false,
      listQuery: {
        gmtCreatedRange:'',
        partyType: 'STAFF',
        name: '',
        phone: '',
        roleCode: '',
        isQueryRole: 1,
        gmtCreatedStart: '',
        gmtCreatedEnd: '',
        branchCode: '',
        departmentCode: '',
        teamCode: '',
        pageNum: 1,
        pageSize: 20,
        sortField: '',
        sortType: '',
        total: 0
      },
      Pagingconf: [],
      roleList: [],
      staffs:[]
    }
  },
  created() {
    this.getRoleList()
    this.getCascadeData()
  },
  methods: {
    setOrgCode(value) {
      this.listQuery.branchCode = value[0]
      this.listQuery.departmentCode = value[1]
      this.listQuery.teamCode = value[2]
    },
    groupNameFormatter({ row }) {
      let gropName = row.branchName;
      if(row.departmentName)
        gropName =gropName + ' / ' + row.departmentName;
      if(row.teamName)
        gropName =gropName + ' / ' + row.teamName;
      return gropName
    },
    // 获取字典数据
    getCascadeData() {
      request({
        url: '/ntocc-basic-api/team/cascadeData',
        method: 'get'
      }).then(response => {
        this.cascadeData = response.data
        this.$refs.groupSelect.initData(this.cascadeData, 'setGroupCode')
      }).then(response => {
        this.findList()
      })
    },

    findList() {
      this.loading = true
      request({
        url: '/ntocc-basic-api/userLogin',
        method: 'get',
        params: this.listQuery
      }).then(response => {
        this.tableData = response.data.records
        this.listQuery.total = response.data.total
          response.data.total>10000? this.Pagingconf = [20, 30, 50, 100,10000]:this.Pagingconf = [20, 30, 50, 100, response.data.total || 1];
        this.loading = false
      })
    },
    // 查询角色列表
    getRoleList() {
      request({
        url: `/ntocc-basic-api/role`,
        method: 'get',
        params: { type: 0 }
      }).then(response => {
        this.roleList = response.data.records
      })
    },
    findStaffs() {
      request({
        url: '/ntocc-basic-api/staffs/notHaveUserLoginStafflist',
        method: 'get',
        params: {  partyType: 'STAFF' }
      }).then(response => {
        this.staffs = response.data
        this.$refs.addRef.$refs.staffSelect.init(this.staffs, 'setStaff')
        this.modelAddFlag = true
      })
    },
    // 添加方法
    funcAdd() {
      this.findStaffs();
    },
    // 修改方法
    funcEdit(code) {
      // this.$refs.editRef.$refs.groupSelect.initData(this.cascadeData, 'setGroupCode')
      this.$refs.editRef.getInfo(code)
      this.modelEditFlag = true
    },
    // 详情方法
    funcDetail(code) {
      this.$refs.detailRef.getInfo(code)
      this.modelDetailFlag = true
    },
    // 删除方法
    funcDelete(row) {
      this.$confirm('确认删除吗？')
        .then(_ => {
          request({
            url: `/ntocc-basic-api/userLogin/`,
            method: 'delete',
            params: { codes: row }
          }).then(response => {
            this.$message({ message: response.msg, type: 'success' })
            this.findList()
          })
        })
        .catch(_ => {})
    },
    changeStartDate(value) {
      this.listQuery.gmtCreatedStart = value + ' 00:00:00'
    },
    changeEndDate(value) {
      this.listQuery.gmtCreatedEnd = value + ' 23:59:59'
    },
    // 增加组件的父方法
    fatherAdd() {
      this.modelAddFlag = false
      this.findList()
    },
    // 编辑组件的父方法
    fatherEdit() {
      this.modelEditFlag = false
      this.findList()
    },
    // 公共取消
    fatherCancel(modelFlag) {
      switch (modelFlag) {
        case 'add':
          this.modelAddFlag = false
          break
        case 'edit':
          this.modelEditFlag = false
          break
        case 'detail':
          this.modelDetailFlag = false
          break
        default:
      }
    },
    // 角色名
    formatterRoleName({ cellValue }) {
      let roleNames = ''
      if (cellValue && cellValue.length > 0) {
        cellValue.forEach(function(val, index, arr) {
          roleNames += val.roleName + ' '
        })
      }
      return roleNames
    }
  }
}
</script>

<style>
    
</style>
